<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h6 class="primary--text">{{ cutout.title }}</h6>
          </v-card-title>
          <v-card-text>
            <div class="info--text">{{ cutout.name }} - {{ cutout.town }}</div>
            <div class="info--text">{{ cutout.fancymins }}</div>

          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    computed: {
      cutout () {
        return this.$store.getters.loadedCutout(this.id)
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      userIsCreator () {
        if (!this.userIsAuthenticated) {
          return false
        }
        return this.$store.getters.user.id === this.cutout.creatorId
      },
      loading () {
        return this.$store.getters.loading
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Cutout/Cutout.vue